/**
 * @file Defines the table columns for an organization public key's authentication log.
 */

import React from "react";
import { Tag, Tooltip } from "antd";

const LABEL_TIME = "Time";
const LABEL_STATUS = "Status";
const LABEL_EMAIL = "Email";
const LABEL_REASON = "Reason";
const LABEL_IP = "IP Address";
const LABEL_EMPTY = "-";

const STATUS_SUCCEEDED = "SUCCEEDED";

const WIDTH_STATUS = 120;
const WIDTH_IP = 140;

/**
 * Renders a value, or a placeholder when it is missing.
 */
const renderEmptyable = (value?: string): React.ReactNode => {
  const hasValue = !!value;

  if (!hasValue) {
    return LABEL_EMPTY;
  }

  return value;
};

const authenticationsColumnsConfig = [
  {
    key: "createdAt",
    title: LABEL_TIME,
  },
  {
    key: "email",
    title: LABEL_EMAIL,
    render: renderEmptyable,
    isSearchable: true,
  },
  {
    key: "ipAddress",
    title: LABEL_IP,
    width: WIDTH_IP,
    render: renderEmptyable,
  },
  {
    key: "status",
    title: LABEL_STATUS,
    width: WIDTH_STATUS,
    /**
     * Renders the authentication status as a colored tag.
     */
    render: (status: string) => {
      const isSucceeded = status === STATUS_SUCCEEDED;
      const color = isSucceeded
        ? "green"
        : "red";

      return <Tag color={color}>{status}</Tag>;
    },
    isFilterEnabled: true,
  },
  {
    key: "reason",
    title: LABEL_REASON,
    /**
     * Renders the refusal reason, truncated with a tooltip, or a placeholder when missing.
     */
    render: (reason?: string) => {
      const hasReason = !!reason;

      if (!hasReason) {
        return LABEL_EMPTY;
      }

      return (
        <Tooltip title={reason}>
          {reason}
        </Tooltip>
      );
    },
    hasTruncation: true,
  },
];

export default authenticationsColumnsConfig;
